import React, {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {Redirect, withRouter} from 'react-router'
import queryString from 'query-string'
import {checkAuthentication} from 'util/checkAuthentication'
import {connect} from 'react-redux'
import {isNil} from 'ramda'
import {Button} from 'reactstrap'
import gql from 'graphql-tag'
import {getConfiguredClient} from 'util/graphqlClient'
import { validSteps } from '../Linkgua/components/SpecialistDetails'

const PleaseHold = () => (<div
    className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
    <div className="app-login-main-content">
      <div className="app-logo-content d-flex align-items-center justify-content-center">
        <Link className="logo-lg" to="/" title="Jambo">
          <img src="/vendors/lingoowl/owl.png" width={200} alt="LingoOwl logotype"
               title="Linkgua logotype"/>
        </Link>
      </div>
      <div className="app-login-content">
        <div className="app-login-header">
          <h1>Connecting to<br/> your Stripe account</h1>
        </div>
        <div className="mb-3 d-flex align-items-center justify-content-between">
          <h2>Please hold!</h2>
        </div>
      </div>
    </div>
  </div>
)

const SomethingIsWrong = ({history}) => (<div
    className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
    <div className="app-login-main-content">
      <div className="app-logo-content d-flex align-items-center justify-content-center">
        <Link className="logo-lg" to="/" title="Jambo">
          <img src="/vendors/lingoowl/owl.png"   width={200} alt="LingoOwl logotype"
               title="Linkgua logotype"/>
        </Link>
      </div>
      <div className="app-login-content">
        <div className="app-login-header">
          <h1>Something is wrong, please go back and try again</h1>
        </div>
        <div className="mb-3 d-flex align-items-center justify-content-between">
          <Button className="text-uppercase" onClick={() => history.push('/signup/specialist')}> Take me back!</Button>
        </div>
      </div>
    </div>
  </div>
)


const connectStripeAccountMutation = gql`
  mutation connectStripeAccount($authorizationCode: String) {
    connectStripeAccount(authorizationCode: $authorizationCode)
  }
`

const connectStripeAccount = async (authorizationCode, setState, state) => {
  if (state == MUTATION_STATES.pending) {
    const result = await getConfiguredClient().mutate({
      mutation: connectStripeAccountMutation,
      variables: {authorizationCode}
    })
    setState(result.data.connectStripeAccount ? MUTATION_STATES.resultOk : MUTATION_STATES.resultNotOk)
  }
}

const MUTATION_STATES = {
  pending: 'pending',
  resultOk: 'resultOk',
  resultNotOk: 'resultNotOk'
}

const StripeHandler = ({authUser, location, history}) => {
  const authorizationCode = (queryString.parse(location.search).code)
  const authorizedAndCodeAvailable = checkAuthentication(authUser) && !isNil(authorizationCode)

  const [mutationState, setMutationState] = useState(MUTATION_STATES.pending)

  useEffect(() => {
    if (authorizedAndCodeAvailable) {
      connectStripeAccount(authorizationCode, setMutationState, mutationState)
    }
  })

  switch (true) {
    case authorizedAndCodeAvailable && mutationState === MUTATION_STATES.pending:
      return (<PleaseHold/>)
    case authorizedAndCodeAvailable && mutationState === MUTATION_STATES.resultOk:
      return (<Redirect to={{pathname: '/specialist/profile', state: {step: validSteps.company}}} />)
    default:
      return (<SomethingIsWrong history={history}/>)
  }
}

const
  mapStateToProps = ({auth}) => {
    const {authUser} = auth
    return {authUser}
  }

export default connect(mapStateToProps)

(
  withRouter(StripeHandler)
)




// WEBPACK FOOTER //
// ./containers/StripeHandler.js